export function columns () {
  return [{
    id: 1, title: 'Device UUID', field: 'UUID', filter: '', filterLabel: 'Filter By UUID'
  },{
    id: 2, title: 'Tenant Name', field: 'Tenant', filter: '', filterLabel: 'Filter By Name'
  }, {
    id: 3, title: 'Public Key', filterType: 'none', vpnIcon: true
  }, {
    id: 4, title: 'Created Date', field: 'created_ts', filter: '', isDate: true
  }];
}